import { glassStyle } from "#theme/styles";
import { trackCtaClick } from "#utils/utils";
import {
  Badge,
  Box,
  Button,
  Heading,
  Icon,
  Link,
  SimpleGrid,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React from "react";
import { FaRobot, FaStopwatch } from "react-icons/fa/index.js";

const MotionSimpleGrid = motion(SimpleGrid);

export const AudienceGateway: React.FC = () => {
  const bg = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("whiteAlpha.900", "gray.800");
  const headingColor = useColorModeValue("gray.800", "white");
  const textColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Box py={16} bg={bg} px={4}>
      <MotionSimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={10}
        maxW="container.lg"
        mx="auto"
        mt="-100px"
        position="relative"
        zIndex="2"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.6 }}
      >
        {/* Card 1: Manual Process Pain */}
        <Box
          {...glassStyle}
          bg={cardBg}
          p={8}
          textAlign="center"
          borderRadius="2xl"
          boxShadow="2xl"
        >
          <VStack spacing={4}>
            <Icon as={FaStopwatch} w={10} h={10} color="orange.400" />
            <Badge colorScheme="orange" variant="subtle" px={3} py={1} borderRadius="full">
              Stop the Bleeding
            </Badge>
            <Heading size="md" color={headingColor}>
              How many hours a week does your team spend on tasks a system should be doing?
            </Heading>
            <Text color={textColor}>
              We've eliminated manual intake, follow-ups, scheduling, invoicing, and reporting for businesses across healthcare, AEC, and professional services — freeing entire work-weeks every month.
            </Text>
            <Button
              as={Link}
              href="/solutions/client-intake"
              colorScheme="orange"
              variant="solid"
              w="full"
              mt={4}
              onClick={() =>
                trackCtaClick({
                  cta_label: "See Client Intake Automation",
                  cta_location: "AudienceGateway",
                  destination_url: "/solutions/client-intake",
                })
              }
            >
              See Client Intake Automation
            </Button>
          </VStack>
        </Box>

        {/* Card 2: Knowledge & Visibility Gap */}
        <Box
          {...glassStyle}
          bg={cardBg}
          p={8}
          textAlign="center"
          borderRadius="2xl"
          boxShadow="2xl"
        >
          <VStack spacing={4}>
            <Icon as={FaRobot} w={10} h={10} color="purple.500" />
            <Badge colorScheme="purple" variant="subtle" px={3} py={1} borderRadius="full">
              One AI. All Your Knowledge.
            </Badge>
            <Heading size="md" color={headingColor}>
              Your team asks you the same questions every week because the answer lives in your head.
            </Heading>
            <Text color={textColor}>
              We build one internal AI assistant that knows everything your company knows — policies, processes, passwords, procedures — and answers instantly, 24/7.
            </Text>
            <Button
              as={Link}
              href="/solutions/knowledge-assistant"
              colorScheme="purple"
              variant="outline"
              w="full"
              mt={4}
              onClick={() =>
                trackCtaClick({
                  cta_label: "See Knowledge Assistant",
                  cta_location: "AudienceGateway",
                  destination_url: "/solutions/knowledge-assistant",
                })
              }
            >
              See the Knowledge Assistant
            </Button>
          </VStack>
        </Box>
      </MotionSimpleGrid>
    </Box>
  );
};
